<template>
  <i class="fa fa-list" aria-hidden="true" @click="setShowNav"></i>
</template>
<script>
  export default {
    components: {
    },
    methods: {
        // 菜单栏操作
        setShowNav(){
            this.$store.commit('setShowNav',!this.$store.state.showNav)
        },
    }
  };
</script>
<style scoped>
.navigation{
  background: #FFFFFF;
  width: 224px;
  position:relative;
  box-shadow: 3px 0 7px -7px #5E5E5E;
}
.navigation .stair{
  width:50px;
  background: #353535;
  height: 100%;
}
.navigation .stair li{
  cursor:pointer;
  padding-top:7px;
  padding-bottom: 7px;
  margin-bottom: 10px;
}
.navigation .stair li:hover,.navigation .stair li.on{
  background: #000000;
}
.navigation .stair .navigation-icon{
  width: 15px;
  height:15px;
  display: block;
  background-size: 100% auto;
  margin: 0 auto;
}
.navigation .stair .navigation-icon.navigation-icon-user{
  background-image:url('../assets/employee/images/navigation-user.png');
  width: 20px;
  height:20px;
}
.navigation .stair li:hover .navigation-icon.navigation-icon-user, .navigation .stair li.on .navigation-icon.navigation-icon-user{
  background-image:url('../assets/employee/images/navigation-user-on.png');
}
.navigation .stair .navigation-icon.navigation-icon-statistics{
  background-image:url('../assets/employee/images/navigation-statistics.png');
}
.navigation .stair li:hover .navigation-icon.navigation-icon-statistics,.navigation .stair li.on .navigation-icon.navigation-icon-statistics{
  background-image:url('../assets/employee/images/navigation-statistics-on.png');
}
.navigation .stair .navigation-icon.navigation-icon-backlog{
  background-image:url('../assets/employee/images/navigation-backlog.png');
}
.navigation .stair li:hover .navigation-icon.navigation-icon-backlog,.navigation .stair li.on .navigation-icon.navigation-icon-backlog{
  background-image:url('../assets/employee/images/navigation-backlog-on.png');
}
.navigation .stair .navigation-icon.navigation-icon-roster{
  background-image:url('../assets/employee/images/navigation-roster.png');
}
.navigation .stair li:hover .navigation-icon.navigation-icon-roster,.navigation .stair li.on .navigation-icon.navigation-icon-roster{
  background-image:url('../assets/employee/images/navigation-roster-on.png');
}
.navigation .stair .navigation-icon.navigation-icon-oa{
  background-image:url('../assets/employee/images/navigation-oa.png');
}
.navigation .stair li:hover .navigation-icon.navigation-icon-oa,.navigation .stair li.on .navigation-icon.navigation-icon-oa{
  background-image:url('../assets/employee/images/navigation-oa-on.png');
}



.navigation .stair .navigation-icon.navigation-icon-jurisdiction{
  background-image:url('../assets/employee/images/navigation-jurisdiction.png');
}
.navigation .stair li:hover .navigation-icon.navigation-icon-jurisdiction,.navigation .stair li.on .navigation-icon.navigation-icon-jurisdiction{
  background-image:url('../assets/employee/images/navigation-jurisdiction-on.png');
}
.navigation .second{
  position:absolute;
  top: 0;
  left: 64px;
  width:160px;
  z-index: 1999;
  background: #FFFFFF;
  height: 100%;
}
.navigation .second .title{
  margin-top:20px;
  font-size: 16px;
  font-weight: bold;
  color: #353535;
  line-height: 22px;
  margin-bottom: 20px;
  padding-left:10px;
}
.navigation .second li{
  line-height: 45px;
  font-size: 14px;
  font-weight: 500;
  color: #353535;
  padding-left:10px;
  cursor: pointer;
}
.navigation .second li.on{
  color: #19BD92;
  background: #EBFAF5;
  font-weight: bold;
  border-right: 4px solid #19BD92;
}
.navigation .second li:hover{
  background: #F3F3F3;
}
.confirm{
  background: #EBFAF5;
  border: 1px solid #19BD92;
  color: #19BD92;
}
.confirm:hover{
  background: #EBFAF5;
  border: 1px solid #19BD92;
  color: #19BD92;
}
.cancel{
  color: #76A196;
  border-radius: 2px;
  border: 1px solid #E1EBE7;
  background: #FFFFFF;
}
.cancel:hover{
  color: #76A196;
  border-radius: 2px;
  border: 1px solid #E1EBE7;
  background: #FFFFFF;
}
</style>